import { clipEndBar, sessionBarsToNative, timelineBars } from '@/audio/clipTiming';
import { classSongMap } from '@/state/classSteps';

const EPS = 1e-6;

export function flow2ClassEnd(classSession, bpm) {
  if (classSession?.flow === 'expo') return Number(classSession.expoBars) || null;
  if (classSession?.flow !== 2) return null;
  return classSongMap(bpm, 2, classSession.mapId).length;
}

export function trimClipAtEnd(clip, bpm, endBar) {
  const start = Number(clip.start_bar || 0);
  if (start >= endBar - EPS) return null;
  if (clipEndBar(clip, bpm) <= endBar + EPS) return clip;
  return {
    ...clip,
    bars: sessionBarsToNative(endBar - start, clip, bpm),
    isWholeLoop: false,
  };
}

export function copyClipAtEnd(clip, startBar, bpm, endBar) {
  if (clipEndBar(clip, bpm) >= endBar - EPS) {
    return { clip: null, notice: 'That one already reaches the End.' };
  }
  const copy = trimClipAtEnd({ ...clip, start_bar: startBar }, bpm, endBar);
  return copy ? { clip: copy, notice: null } : { clip: null, notice: 'That one already reaches the End.' };
}

export function clampClipStartAtEnd(clip, requestedStart, bpm, endBar) {
  return Math.max(0, Math.min(Number(requestedStart) || 0, endBar - timelineBars(clip, bpm)));
}

export function growSongToFit(lastEnd, totalBars, { flow = 1, mapLength = null, maxBars = 80 } = {}) {
  if (flow === 2 || flow === 'expo') return Number(mapLength) || totalBars;
  return lastEnd > totalBars + EPS ? Math.min(maxBars, Math.ceil(lastEnd / 4) * 4) : totalBars;
}

export function zoomToFitSong(mapLength, visibleTimelineWidth, pixelsPerBar = 52) {
  const raw = Number(visibleTimelineWidth) / ((Number(mapLength) + 2) * pixelsPerBar);
  return Math.max(0.25, Math.min(3, Number(raw.toFixed(2))));
}
